import {DateTime} from "luxon";

export const isIOS = navigator.userAgent.includes('iPhone') || navigator.userAgent.includes('iPad');
export const negativeInputMode = isIOS ? 'text' : 'numeric';

export const isAprilFool = DateTime.now().month === 4 && DateTime.now().day === 1;

